import { render, staticRenderFns } from "./View404.vue?vue&type=template&id=799571b9&"
import script from "./View404.vue?vue&type=script&lang=js&"
export * from "./View404.vue?vue&type=script&lang=js&"
import style0 from "./View404.vue?vue&type=style&index=0&id=799571b9&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports